/*
 * Componente para el filtro de empresas
 */
import { isFunction, debounce } from "lodash";
import React, { Component } from "react";
import { TextField } from "material-ui";
import SearchIcon from "material-ui/svg-icons/action/search";

class FiltroEmpresas extends Component {
	constructor() {
		super();
		this.state = { search: "" };
		this.sendNotification = this.sendNotification.bind(this);
	}

	sendNotification() {
		if (isFunction(this.props.onChange)) {
			this.props.onChange(this.state.search);
		}
	}

	render() {
		const { placeholder = "" } = this.props;
		const onChange = (event, search) => {
			this.setState({ search }, debounce(this.sendNotification, 500));
		};
		return (
			<div style={{ position: "relative" }}>
				<TextField
					id="searchCompany"
					value={this.state.search}
					onChange={onChange}
					placeholder={placeholder}
					fullWidth
					style={{ textIndent: 30 }}
					inputStyle={{ color: "#616161" }}
				/>
				<SearchIcon
					style={{
						position: "absolute",
						left: 0,
						top: 15,
						width: 20,
						height: 20
					}}
					color={"#b1b1b1"}
				/>
			</div>
		);
	}
}

export default FiltroEmpresas;



// WEBPACK FOOTER //
// ./src/screens/biCharts/InputFiltroEmpresas.js